import { List } from '@mui/material';
import { useEntityChildren } from 'api/entity';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { SearchResultEntityListItems } from '../components/entityList';
import { SearchQuery } from '../processQuery';

export function SearchChildren(props: {
  value: SearchQuery;
  onClick: (open: boolean) => void;
}) {
  const { value, onClick: setOpen } = props;
  const params = useParams();
  const entityId = params.id;
  const { data } = useEntityChildren(
    value.queryOptions.type === 'children'
      ? value.queryOptions.entityId
      : value.queryOptions.type === 'currentEntity'
        ? entityId
        : undefined,
  );

  const { queryText } = value;

  const filteredEntities = useMemo(
    () =>
      data?.filter((x) => {
        if (x.name.toLowerCase().includes(queryText.toLowerCase())) {
          return true;
        }

        if (x.description?.toLowerCase().includes(queryText.toLowerCase())) {
          return true;
        }

        return false;
      }) ?? [],
    [data, queryText],
  );

  return (
    <List disablePadding>
      <SearchResultEntityListItems
        entities={filteredEntities ?? []}
        onClick={setOpen}
      />
    </List>
  );
}
